module.exports = __webpack_public_path__ + "img/paginationright.e7db5357.svg";